'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$16() {
  this.be7 = null;
  this.be5 = null;
  this.be6 = false;
  this.be3 = null;
  this.be4 = false;
  this.be8 = false;
  this.be9 = false;
  this.be7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$16 as $c_Lpresto_PrestoRouter$$anon$16 };
$p = $c_Lpresto_PrestoRouter$$anon$16.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$16;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$16() {
}
export { $h_Lpresto_PrestoRouter$$anon$16 as $h_Lpresto_PrestoRouter$$anon$16 };
$h_Lpresto_PrestoRouter$$anon$16.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.be7;
});
$p.t = (function() {
  if ((!this.be6)) {
    this.be5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.be6 = true;
  }
  return this.be5;
});
$p.ad = (function() {
  if ((!this.be4)) {
    this.be3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.be4 = true;
  }
  return this.be3;
});
$p.v = (function() {
  if ((!this.be9)) {
    this.be8 = false;
    this.be9 = true;
  }
  return this.be8;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$16 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$16, "presto.PrestoRouter$$anon$16", ({
  NP: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$16 as $d_Lpresto_PrestoRouter$$anon$16 };
//# sourceMappingURL=presto.-Presto-Router$$anon$16.js.map
